module.exports = __webpack_public_path__ + "img/accessoire.e514e742.png";